import React from 'react';

import type { InformationModalProps } from '../../common/ui/InformationModal';

export type RovoDebuggingPanelProps = InformationModalProps;

const InformationModalLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_rovo-debugging-panel-information-modal" */ '../../common/ui/InformationModal'
		),
);

export const RovoDebuggingPanel = ({
	isOpen,
	onClose,
	assistanceServiceParams,
	conversationId,
	testId,
}: RovoDebuggingPanelProps): JSX.Element => {
	return (
		<React.Suspense fallback={null}>
			<InformationModalLazy
				isOpen={isOpen}
				onClose={onClose}
				assistanceServiceParams={assistanceServiceParams}
				conversationId={conversationId}
				testId={testId}
			/>
		</React.Suspense>
	);
};
